import React from "react";

import { ProductRibbon } from "../../ProductRibbon/ProductRibbon";

import { verticalProductCardRibbon } from "./VerticalProductCard.css";
import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<ProductCardDataType, "ribbon" | "image">;
};

export const VerticalProductCardRibbon: React.FC<Props> = ({ product }) => {
  if (!product.ribbon?.ribbonKey || !product.ribbon.text || !product.image?.src)
    return null;

  return (
    <div
      className={verticalProductCardRibbon}
      data-testid="vertical-product-card-ribbon"
    >
      <ProductRibbon
        ribbonKey={product.ribbon.ribbonKey}
        text={product.ribbon.text}
      />
    </div>
  );
};
